import {TinaEvents} from "./tina.events";

export const DianaEvents = {};

DianaEvents.hasActiveEvent = () => {
  return DianaEvents.isFirstEvent() ||
      DianaEvents.firstMeet() ||
      DianaEvents.isDianaCuriosityEvent() ||
      DianaEvents.somberAndHeavy() ||
      DianaEvents.regrets() ||
      DianaEvents.revelation()
}

DianaEvents.displayHint = () => {
  return DianaEvents.firstMeet() ||
      DianaEvents.isDianaCuriosityEvent() ||
      DianaEvents.somberAndHeavy() ||
      DianaEvents.regrets() ||
      DianaEvents.revelation()
}

DianaEvents.isFirstEvent = () => {
  if(EventStateService.dianaDailyEventChecked) {
    return false;
  }

  // czy już drugi rozdział
  if(!EventStateService.secondChapterIntro) {
    return false;
  }

  return !EventStateService.dianaFirstEvent
}

DianaEvents.firstMeet = () => {
  if(EventStateService.dianaDailyEventChecked) {
    return false;
  }

  if(!EventStateService.dianaFirstEvent) {
    return false;
  }

  // Czy MC pracował już 3 razy
  if(Yosemite.EventStateManager.timesWorkedMarketing < 3) {
    return false;
  }

  // Czy jest rano
  if(YsControllers.TimeController.getCurrentDayTime() !== YsControllers.TimeController.DayTimeEnum.MORNING) {
    return false;
  }

  return !EventStateService.dianaFirstMeet
}

DianaEvents.isDianaCuriosityEvent = () => {
  if(EventStateService.dianaDailyEventChecked) {
    return false;
  }

  // Czy jest rano
  if(YsControllers.TimeController.getCurrentDayTime() !== YsControllers.TimeController.DayTimeEnum.MORNING) {
    return false;
  }

  // Czy odbył się poprzedni event
  if(!EventStateService.dianaFirstMeet) {
    return false;
  }

  return !EventStateService.dianaCuriosityEvent
}

DianaEvents.somberAndHeavy = () => {
  if(EventStateService.dianaDailyEventChecked) {
    return false;
  }

  // Czy jest rano
  if(YsControllers.TimeController.getCurrentDayTime() !== YsControllers.TimeController.DayTimeEnum.MORNING) {
    return false;
  }

  // czy był somberAndHeavy event
  if(!EventStateService.dianaCuriosityEvent) {
    return false;
  }

  return !EventStateService.dianaSomberAndHeavy;
}

DianaEvents.regrets = () => {
  // daily event check
  if(EventStateService.dianaDailyEventChecked) {
    return false;
  }

  // czy poprzedni event event
  if(!EventStateService.dianaSomberAndHeavy) {
    return false;
  }

  return !EventStateService.dianaRegrets;
}

DianaEvents.revelation = () => {
  // daily event check
  if(EventStateService.dianaDailyEventChecked) {
    return false;
  }

  // czy poprzedni event event
  if(!EventStateService.dianaRegrets) {
    return false;
  }

  return !EventStateService.dianaRevelation;
}

